{
    let msg_bar = document.querySelector('.message-bar__close');

    if (msg_bar) {
        msg_bar.addEventListener('click', () => {
            document.querySelector('.message-bar').classList.add('hide');
            let header = document.querySelector('.header');

            if (!header) return;

            wm_set_scroll_padding(header);
        });
    }
}
